export default __webpack_public_path__ + "locales/ru/SmartBanner.json?hash=65dfd845828e051f2f1df9be87790b7b";